import React from 'react';
import ProfileDetails from './ProfileDetails';

interface Profile {
  id: string;
  candidateName?: string;
  profileUrl?: string;
  summary?: string;
  email?: string;
  phone?: string;
  linkedInLink?: string;
  industries?: string[];
  experiences: any[];
  anonymizedProfile?: any;
}

interface ProfileDetailsDrawerProps {
  profile: Profile | null;
  isOpen: boolean;
  onClose: () => void;
  onAddToShortlist: (profileId: string) => void;
  isInShortlist: boolean;
  hideShortlistButton?: boolean;
}

const ProfileDetailsDrawer: React.FC<ProfileDetailsDrawerProps> = ({
  profile,
  isOpen,
  onClose,
  onAddToShortlist,
  isInShortlist,
  hideShortlistButton = false,
}) => {
  if (!profile) return null;

  return (
    <>
      {/* Backdrop */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-[60]"
          onClick={onClose}
        />
      )}

      {/* Drawer */}
      <div className={`fixed top-0 right-0 h-full w-full sm:w-[600px] z-[70] transform transition-transform duration-300 ease-in-out ${isOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
        style={{
          backgroundColor: '#FFFFFF',
          borderLeft: '1px solid #E5E7EB'
        }}>
        <div className="h-full flex flex-col">
          {/* Profile Details Content with integrated header */}
          <div className="flex-1 overflow-y-auto">
            <ProfileDetails
              profile={profile}
              onAddToShortlist={onAddToShortlist}
              isInShortlist={isInShortlist}
              showAddToShortlist={!hideShortlistButton}
              showCloseButton={true}
              onClose={onClose}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ProfileDetailsDrawer;